<template>
    <div ref="promoNotificationsButtonRef"
         class="mobile-menu-button d-flex justify-content-center align-items-center flex-grow-1 position-relative p-2"
         :class="{ 'card-shadow': hasShadow }"
         :aria-label="getTrans('header.notifications', 'Notifications')"
         @click="openNotificationModal">
        <i class="fa-solid fa-grid" />
        <div class="dot-wrapper">
            <div class="dot" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {
        h, watchEffect, ref,
    } from 'vue';
    import { getTrans } from '@/js/helpers/getTrans';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import useTippyPopup from '../../composables/useTippyPopup';
    import DesktopNotificationsTippy from '../../quests/dashboard/navigation/desktop/DesktopNotificationsTippy.vue';
    import { useMenuStore } from '@/js/store/menu/MenuStore';

    withDefaults(defineProps<{
        hasShadow: boolean,
    }>(), {
        hasShadow: true,
    });

    const menuStore = useMenuStore();

    const { isMobileOrTablet } = useDeviceSize();

    const promoNotificationsButtonRef = ref(null);

    const openNotificationModal = () => {
        if (isMobileOrTablet.value) {
            menuStore.isNotificationsModalOpen = true;
        }
    };

    const { disable, enable } = useTippyPopup(promoNotificationsButtonRef, {
        content: h(DesktopNotificationsTippy, {
            notifications: menuStore.promoNotifications,
            closeTippy: () => {},
        }),
        placement: 'top',
        interactive: true,
        trigger: 'click',
        theme: 'base',
    });

    watchEffect(() => {
        if (isMobileOrTablet.value) {
            disable();
        } else {
            enable();
        }
    });
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.dot-wrapper {
    position: absolute;
    left: 50%;
    width: 18px;
    height: 18px;
    transform: translateX(-50%);

    .dot {
        position: absolute;
        top: -1px;
        right: -2px;
        width: 9px;
        height: 9px;
        border-radius: 5px;
        background-color: legacyVariables.$down-color;
        pointer-events: none;

        &::after {
            position: absolute;
            width: 15px;
            height: 15px;
            border-radius: 8px;
            margin: auto;
            animation: pulse-me 1.7s linear infinite;
            background-color: legacyVariables.$down-color;
            content: "";
            inset: 0 0 0 -3px;
            transform: scale(0.4);
            transform-origin: center center;
        }
    }
}
</style>
